import { escapeTag } from "../../common/Utils";

class AutoSuggest{
    constructor(){}

    init( _option ){
        this.option = jQuery.extend(true, {
            isGDPRGeoCountry: false,
            apiUrl: '',
            selector : '#autoSuggest',
            size: 10,
            useDelbtn: false,
            cookieName: 'autosuggest',
            locale: 'ko-KR',
            submitCallback: _q => console.log( 'query :', _q, '::: option.submitCallback 설정은 필수 입니다' ),
        }, _option);

        this.loadedKeyword = '';
        this.dataBaseKeyword = '';
        this.isValueFunctionText = '';
        this.apiUrl = this.option.apiUrl;

        this.suggestWrap = jQuery(this.option.selector + " [data-name='suggest_wrap']");
        this.input = jQuery(this.option.selector + " [data-name='suggest_input']");
        this.submitBtn = jQuery(this.option.selector + " [data-name='suggest_submit']");
        this.deleteBtn = jQuery(this.option.selector + " [data-name='suggest_delete']").hide();
        this.resultUL = jQuery(this.option.selector + " [data-name='suggest_scroll'] ul");

        // GDPR 대상 국가(쿠키 법령 존재하는 국가) 확인하여, 기능/개인화 쿠키 사용 여부 설정
        // @see https://jira.ncsoft.com/browse/PSD-10182
        this.isCookieApply = false;
        if (this.option.isGDPRGeoCountry) {
            // GDPR 대상 국가 case : 기능/개인화 쿠키 허용 여부를 확인하여, 쿠키 사용 설정
            this.isCookieApply = this.checkFunctionalCookieEnabled();
        }else{
            // GDPR 대상 국가 아님 case : 쿠키 사용 설정
            this.isCookieApply = true;
        }

        if (this.isCookieApply) {
            this.recentUL = jQuery(this.option.selector + " [data-name='suggest_recent_scroll'] ul");
            this.recentWrap = jQuery(this.option.selector + " [data-name='suggest_recent']").hide();
            this.recentAllDel = jQuery(this.option.selector + " [data-name='suggest_recent-del'] button");
            this.recentNone = jQuery(this.option.selector + " [data-name='suggest_recent-none']");
            this.recentData = JSON.parse( unescape( this.getCookie(this.option.cookieName) ) ) || [];
            this.makeRecentList();
        }

        this.addEvents();
    }

    load(_newKeyword){
        if(this.ajaxCall && this.ajaxCall.abort) this.ajaxCall.abort();

        this.loadedKeyword = _newKeyword;

        this.ajaxCall = jQuery.ajax({
            url: this.apiUrl,
            xhrFields: {withCredentials: true}, dataType: "json", type: "GET",
            data: jQuery.param({
                keyword: this.loadedKeyword, size: this.option.size,
                locale: this.option.locale 
            })
        })
        .done( _data => this.drawList(_data) )
        .fail( e => console.log('::::::::::fail::::::::::', e) );
    }

    addEvents(){
        let eventType = (window._device && window._device==='ingame')? 'keypress': 'keydown';
        this.input.on(eventType+'.autoSuggest', (e)=>{
            if ( e.keyCode === 27 ) { // ESC
                this.input.val(this.loadedKeyword);
                this.suggestWrapToggle(false);
                return false;
            }

            if ( e.keyCode === 13 ) { // Enter
                this.submitGo();
                this.submitBtn.focus();
                return false;
            }

            if ( e.keyCode === 9 ) { // Tab
                this.focusChange( !e.shiftKey? 1: -1 );
                return false;
            }

            if ( e.keyCode === 40) { // ↓
                this.focusChange(1);
                return false;
            }

            if ( e.keyCode === 38 ) { // ↑
                this.focusChange(-1);
                return false;
            }
        });

        this.input.on( 'focusout', e => {
            if(this.sto){
                clearTimeout( this.sto );
                this.sto = null;
            }
            setTimeout( () => {
                this.suggestWrapToggle(false);
                if (this.isCookieApply) this.recentWrap.toggle(false);
                // this.suggestWrap.toggle(false);
            } , 150 );
        });

        this.input.on( 'focusin', e => {
            this.isValueFunctionText = '';
            if( !this.sto ) this.realTimeInputCheck();
            this.suggestWrap.toggle(true);
            if( this.resultUL.find('li').length ) {
                this.suggestWrapToggle(true);
            }
        });

        this.submitBtn.on( 'click', e => this.submitGo() );
        
        if (this.isCookieApply){
            this.recentAllDel.on( 'click', e => {
                this.recentData = [];
                this.setCookie(this.option.cookieName, JSON.stringify(this.recentData));
                this.makeRecentList();
                this.input.val( '' ).focus();
            });
            this.recentUL.on( 'click', 'li [type="button"]', e => {
                const key = e.currentTarget.dataset.key;
                const idx = this.recentData.indexOf( key );
    
                this.recentData.splice(idx,1);
                this.setCookie(this.option.cookieName, JSON.stringify(this.recentData));
                this.makeRecentList();
                this.input.val( '' ).focus();
            });
        }

        this.deleteBtn.on( 'click', e => {
            this.loadedKeyword = '';
            this.input.val( '' ).focus();
        });

        this.resultUL.on( 'mouseover', 'li', e => {
            this.resultUL.find('li').removeClass('focus');
            jQuery(e.currentTarget).addClass('focus');
        });
    }

    realTimeInputCheck(){
        if(this.sto){
            clearTimeout( this.sto );
            this.sto = null;
        }

        const inputTxt = this.input.val().trim();

        // 문자열이 있나?
        if( inputTxt ){
            // 바로 앞에서 api 호출한 문자열 인가?
            // 화살표 이동을 통해 입력된 문자열 인가?
            if( this.loadedKeyword !== inputTxt && this.dataBaseKeyword !== inputTxt && this.isValueFunctionText !== inputTxt ){
                this.load( inputTxt );
                this.isValueFunctionText = '';
            }
        } else {
            if (this.isCookieApply) this.recentWrap.toggle(true);
            
            if(this.loadedKeyword != '') {
                setTimeout(()=>{
                    if( this.input.val().trim() ) return;
                    this.loadedKeyword = '';
                }, 10);
            }
            if(this.resultUL.html() != '') {
                setTimeout(()=>{
                    this.resultUL.html('');
                    this.suggestWrapToggle(false);
                }, 10);
            }
        }

        this.deleteBtnToggle(inputTxt);
        this.sto = setTimeout(()=>this.realTimeInputCheck(), 10);
    }

    deleteBtnToggle(inputTxt = ''){
        if(!this.option.useDelbtn) return false;

        if(inputTxt){
            if(!this.deleteBtnIsShow){
                this.deleteBtn.show();
                this.deleteBtnIsShow = true;
            }
        }else{
            if(this.deleteBtnIsShow){
                this.deleteBtn.hide();
                this.deleteBtnIsShow = false;
            }
        }
    }

    drawList(_data){
        if(!this.input.val().trim()) {
            return; // 인풋에 문자열 없으면 데이터가 들어와도 보여주지 않는다.
        }
        
        if (this.isCookieApply) this.recentWrap.toggle(false);

        this.suggestWrapToggle(_data.length>0);
        this.listRemoveEvent();

        let list = '';
        if(_data.length){
            let key = this.loadedKeyword.replace('(', '\\(').replace(')', '\\)');
            let reg = new RegExp(key, 'i');
            list = _data.map( (item, idx) => {
                const regStr = reg.exec(item);
                const str = item.replace(regStr, `<mark>${regStr}</mark>`);
                return `<li data-idx="${idx}" data-keyword="${item}">${str}</li>`; 
            } ).join('');
        }
        this.resultUL.html(list);
        this.listAddEvent();
    }

    listRemoveEvent(){
        jQuery( this.option.selector + " [data-name='suggest_scroll'] ul li" ).off('click');
    }

    listAddEvent(){
        jQuery( this.option.selector + " [data-name='suggest_scroll'] ul li" ).on('click', e => {
            this.input.val( e.currentTarget.dataset.keyword );
            this.submitGo();
        });
    }

    focusChange( _direction = 1 ){
        let newFocusEl;
        let oldFocusEl = this.resultUL.find('.focus');

        if(_direction === 1){
            newFocusEl = ( oldFocusEl.length )? oldFocusEl.next(): this.resultUL.find('li').first();
        }
        if(_direction === -1){
            newFocusEl = ( oldFocusEl.length )? oldFocusEl.prev(): this.resultUL.find('li').last();
        }

        this.resultUL.find('li').removeClass('focus');

        this.suggestWrapToggle(newFocusEl.length>0);

        if( newFocusEl.length ){
            newFocusEl.addClass('focus');
            this.dataBaseKeyword = newFocusEl.data('keyword');
            this.input.val( this.dataBaseKeyword );
        }
    }

    submitGo() {
        this.suggestWrapToggle(false);

        const keyword = this.input.val().trim();

        if (typeof this.option.submitCallback === 'function' && keyword !== '') {
            this.setRecentList(keyword);
            this.option.submitCallback( keyword );
        }
    }

    suggestWrapToggle(_isShow=true){
        // this.suggestWrap.toggle(_isShow);
        jQuery(this.option.selector + " [data-name='suggest_list']").toggle(_isShow);
        if(!_isShow) this.resultUL.find('li').removeClass('focus');
    }

    setRecentList(_keyword){
        if (!this.isCookieApply) return false;
        if( this.recentData.indexOf(_keyword) === -1 ){
            this.recentData.unshift(_keyword);
            this.recentData.splice(5);
            this.setCookie(this.option.cookieName, JSON.stringify(this.recentData));
            this.makeRecentList();
        }
    }
    
    makeRecentList(){
        if (!this.isCookieApply) return false;
        let list = this.recentData.map( it => `<li data-keyword="${it}">${escapeTag(it)}<input type="button" data-key="${it}" value="X" title="검색어 삭제"></li>` );
        this.recentNone.toggle(!this.recentData.length);
        this.recentAllDel.toggle(this.recentData.length>0);
        this.recentUL.html(list);
        this.recentListAddEvent();
    }

    recentListAddEvent(){
        if (!this.isCookieApply) return false;
        jQuery( this.option.selector + " [data-name='suggest_recent_scroll'] ul li" ).on('click', e => {
            if(e.target.value === "X") return;
            this.input.val( e.currentTarget.dataset.keyword );
            this.submitGo();
            this.deleteBtnToggle(this.input.val());
        });
    }

    setCookie(name = '', value = '', expiredays = 365, domain = 'plaync.com') {
        let todayDate = new Date();
        todayDate.setDate(todayDate.getDate() + expiredays);
        document.cookie = `${name}=${escape(value)}; path=/; domain=${domain};expires=${todayDate.toGMTString()};SameSite=Lax;`;
    }
    
    getCookie(name = '') {
        let cookies = document.cookie;
        if (cookies.indexOf(name) == -1) return false;
        let cookie = cookies.substr(cookies.indexOf(name));
        cookie = cookie.split(';')[0];
        cookie = cookie.substr(cookie.indexOf('=') + 1);
        return cookie;
    }

    checkFunctionalCookieEnabled() {
        // 기능/개인화 쿠키 사용가능 여부 확인('applyCode' 쿠키의 typeArr 배열의 'FUNCTIONAL' 존재 여부)
        // @see https://wiki.ncsoft.com/pages/viewpage.action?pageId=823197543#tab-%EA%B0%9C%EC%9A%94
        const cookieData = JSON.parse(decodeURIComponent(this.getCookie('applyCookie')) || '{}');
        return !!cookieData?.typeArr?.includes('FUNCTIONAL'); 
    }
    
    // public ---------------------------------------------------------------------
    value(_txt){
        this.isValueFunctionText = _txt;
        this.input.val(_txt);
    }

}

export default AutoSuggest;
